import { Audio, PositionalAudio } from "three";

export function isThreeAudio(node: any): node is Audio | PositionalAudio {
  return node instanceof Audio || node instanceof PositionalAudio;
}
